import {logUtil} from "@repo/lib-common";

logUtil.setLogPrefix("domain-client")

export interface ICommand {
    command: VoidFunction | undefined;
    hasError: boolean;
    exception: unknown

}

export class CommandArray {
    waiting: Array<VoidFunction> = [];
    executed: Array<ICommand> = [];
    isProcessing: boolean = false;
    canProcess:boolean=false;


    push(f: VoidFunction): number {
        const num = this.waiting.push(f);
        if (!this.isProcessing && this.canProcess) {
            this.processQueue();
        }
        return num;
    }

    processQueue(): void {
        if (this.isProcessing) {
            logUtil.consoleLog("already processing queue");
            return;
        }
        if (this.isProcessing) {
            this.isProcessing = true;
        }
        try {
            while (this.waiting.length > 0) {
                const commandFunc = this.waiting.shift();
                let hasError = false;
                let exception = null;
                try {
                    if (commandFunc) {
                        commandFunc();
                    }
                } catch (e) {
                    hasError = true;
                    exception = e;
                    logUtil.consoleError("processQueue error", e);
                }
                this.executed.push({command: commandFunc, hasError: hasError, exception: exception});
            }
        } catch (ex) {
            logUtil.consoleError(ex);
        } finally {
            this.isProcessing = false;
        }
    }

}
